import axios from 'axios';

const getId = (value) => (value && typeof value === 'object' ? (value._id || value.id || '') : value || '');

export async function resolveManufacturerNameId(component) {
  if (!component?.manufacturerId) return '';

  if (typeof component.manufacturerId === 'object') {
    if (component.manufacturerId.manufacturerName) {
      return typeof component.manufacturerId.manufacturerName === 'object'
        ? component.manufacturerId.manufacturerName._id
        : component.manufacturerId.manufacturerName;
    }
    return '';
  }

  try {
    const mfrResponse = await axios.get(`/api/master-data/manufacturers/${component.manufacturerId}`);
    if (mfrResponse.data?.manufacturerName) {
      return typeof mfrResponse.data.manufacturerName === 'object'
        ? mfrResponse.data.manufacturerName._id
        : mfrResponse.data.manufacturerName;
    }
  } catch (error) {
    console.error('Error fetching manufacturer:', error);
  }
  return '';
}

/**
 * Build ComponentForm state from an existing component record (edit or clone).
 */
export async function buildComponentFormDataFromRecord(component, overrides = {}) {
  const manufacturerNameId = await resolveManufacturerNameId(component);
  const base = {
    aircraftId: getId(component.aircraftId),
    assemblyId: getId(component.assemblyId),
    ataChapterId: getId(component.ataChapterId),
    partId: getId(component.partId),
    partNumber: component.partNumber || '',
    partName: (typeof component.partId === 'object' && component.partId?.partName)
      ? String(component.partId.partName).trim()
      : '',
    description: component.description || '',
    serialNumber: component.serialNumber || '',
    position: component.position || '',
    manufacturerId: manufacturerNameId,
    monitorTypeId: getId(component.monitorTypeId),
    installedOnDate: component.installedOnDate
      ? new Date(component.installedOnDate).toISOString().split('T')[0]
      : '',
    licenseId: getId(component.licenseId),
    workOrderNumber: component.workOrderNumber || '',
    notes: component.notes || '',
    asReceivedEvidenceFrom: component.asReceivedEvidenceFrom || '',
    isInitialLoad: !!component.isInitialLoad,
    isActive: component.isActive !== false,
    code: component.code || '',
    timeSinceRecords: Array.isArray(component.timeSinceRecords)
      ? component.timeSinceRecords.map((record) => ({ ...record }))
      : []
  };

  const merged = { ...base, ...overrides };
  if (overrides.partNumber != null && overrides.partId === undefined) {
    const normalizedOverride = String(overrides.partNumber || '').trim().toUpperCase();
    const normalizedSource = String(component.partNumber || '').trim().toUpperCase();
    if (normalizedOverride && normalizedOverride !== normalizedSource) {
      merged.partId = '';
    }
  }
  return merged;
}
